import { createSlice } from "@reduxjs/toolkit";

const initialState = {

}

const healthCareProfessionalSlice = createSlice({
    name: 'healthcareprofessionals',
    initialState,
    reducers: {},
})

export const {} = healthCareProfessionalSlice.actions

export default healthCareProfessionalSlice.reducer;